///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthPreloaderModalEvent } from '../../../../../shared/preloader-modal/preloader-modal-event';
import { GtthToolbarModeChangedCommand } from '../toolbar/toolbar-mode-changed-command';
import { ActionsToolbarModeEnum } from '../../../../../generated/shared-types.model';

export class GtthUnlockProjectCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthUnlockProjectCommand';
    }

    doCommand(): void {
        if (this.historyService.isEditModeEnabled) {
            this.historyService.eventManager.broadcast({
                name: 'togglePreloaderModal',
                eventObject: GtthPreloaderModalEvent.show('Loading')
            });

            this.historyService
                .doCommandBypassHistory(this.historyService.command(GtthToolbarModeChangedCommand).create(ActionsToolbarModeEnum.POINTER))
                .then(() => {
                    const mainConfig = this.historyService.logicalTopology.toGeoJsonMainConfig(this.historyService, this.project.name);
                    const activity = this.createActivityDTO(false);
                    activity.logicalTopology = mainConfig;
                    this.sendActivity(activity);
                });
        } else {
            this.commandResolve(true);
        }
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (this.commandResolve) {
            this.historyService.isEditModeEnabled = false;
            this.historyService.editModeEnabledChangedSubject.next(this.historyService.isEditModeEnabled);
            this.historyService.logicalTopology.disableEntitiesListeners();
            this.commandResolve(activityDTO.successful);
        } else {
            this.historyService.resolveRequestLockCommand(activityDTO.userLogin);
        }

        this.historyService.eventManager.broadcast({
            name: 'togglePreloaderModal',
            eventObject: GtthPreloaderModalEvent.hide()
        });
        this.historyService.projectStateService.clearProjectLocked();
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
